import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeacherSkillPathsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SkillPathSettingsFilterInput>;
}>;


export type TeacherSkillPathsQuery = { __typename?: 'RootQueryType', skillPathSettings?: { __typename?: 'KeysetPageOfSkillPathSettings', count?: number | null, results?: Array<{ __typename?: 'SkillPathSettings', id: string, startDate?: any | null, dueDate: any, guideLevelId: string, guideLevel: { __typename?: 'GuideLevel', id: string, name: string, code?: string | null, guideId: string, subjectId: string, parent?: { __typename?: 'GuideLevel', id: string, parent?: { __typename?: 'GuideLevel', id: string } | null } | null }, studentSkillPaths: Array<{ __typename?: 'StudentSkillPath', studentId: string, classroomId: string }> }> | null } | null };


export const TeacherSkillPathsDocument = gql`
    query TeacherSkillPaths($filter: SkillPathSettingsFilterInput) {
  skillPathSettings(
    filter: $filter
    first: 50
    sort: [{field: GUIDE_LEVEL_ID, order: ASC}]
  ) {
    count
    results {
      id
      startDate
      dueDate
      guideLevelId
      guideLevel {
        id
        name
        code
        guideId
        subjectId
        parent {
          id
          parent {
            id
          }
        }
      }
      studentSkillPaths {
        studentId
        classroomId
      }
    }
  }
}
    `;

/**
 * __useTeacherSkillPathsQuery__
 *
 * To run a query within a React component, call `useTeacherSkillPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherSkillPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherSkillPathsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTeacherSkillPathsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>(TeacherSkillPathsDocument, options);
      }
export function useTeacherSkillPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>(TeacherSkillPathsDocument, options);
        }
// @ts-ignore
export function useTeacherSkillPathsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>;
export function useTeacherSkillPathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherSkillPathsQuery | undefined, TeacherSkillPathsQueryVariables>;
export function useTeacherSkillPathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>(TeacherSkillPathsDocument, options);
        }
export type TeacherSkillPathsQueryHookResult = ReturnType<typeof useTeacherSkillPathsQuery>;
export type TeacherSkillPathsLazyQueryHookResult = ReturnType<typeof useTeacherSkillPathsLazyQuery>;
export type TeacherSkillPathsSuspenseQueryHookResult = ReturnType<typeof useTeacherSkillPathsSuspenseQuery>;
export type TeacherSkillPathsQueryResult = Apollo.QueryResult<TeacherSkillPathsQuery, TeacherSkillPathsQueryVariables>;